import { render, staticRenderFns } from "./RegularFilter.vue?vue&type=template&id=63ca25e7&scoped=true"
import script from "./RegularFilter.vue?vue&type=script&lang=js"
export * from "./RegularFilter.vue?vue&type=script&lang=js"
import style0 from "./RegularFilter.vue?vue&type=style&index=0&id=63ca25e7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63ca25e7",
  null
  
)

export default component.exports